import { LoadState } from "../../constants/enums";
import {
  IFoodeMenuCategoryState,
  IMasterFoodMenu,
  IFoodMenuCategory,
  IFoodState,
  ILeadFoodMenu,
} from "./food.types";

export const initialFoodMenu: IMasterFoodMenu = {
  master_menu_uuid: null,
  title: "",
  description: "",
  menu_json: [],
  company_outlet_uuid: null,
  status: "ACTIVE",
  added_lead_menu_uuid: null,
  attachments: [],
  tags: [],
  is_fixed: 0,
  price: 0,
  tax_type: "GST"
};

export const initialLeadFoodMenu: ILeadFoodMenu = {
  added_lead_menu_uuid: null,
  leads_uuid: null,
  title: "",
  description: "",
  menu_json: [],
  company_outlet_uuid: null,
  status: "ACTIVE",
  master_menu_uuid: null,
  master_menu_name: null,
  master_menu_price: null,
};

export const initialFoodState: IFoodState = {
  foodMenu: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  singleFoodMenu: {
    data: initialFoodMenu,
    loading: LoadState.NotLoaded,
    error: null,
  },
  foodItem: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
  leadFoodMenu: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  foodCategory: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
};

export const initialCategory: IFoodMenuCategory = {
  category_unique_id: 0,
  category_uuid: "",
  category_name: "",

  subcategories: [],
  category_description: "",
  company_outlet_uuid: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: null,
  modified_by_name: null,
  create_ts: "",
  insert_ts: "",
  food_items: [],
};

export const initialFoodMenuCategoryState: IFoodeMenuCategoryState = {
  categoryList: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
};
